import React from 'react';
import { useHistory } from "react-router-dom";
import BreadCrumbs from '../../Common/BreadCrumbs';
import {
    PrimaryButton,
} from '../../Common';

const Error500 = ({

}) => {

    const history = useHistory();

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: `An Error Occurred`, onClick: null }
                ]}
            />

            <div className="flex f-col f-center">

                <img src="/images/Error.svg" />

                <br /><br />

                <p className="error404-text">Something went wrong, but we're working on it.</p>

                <br />

                <p className="error404-text-small">We apologize for the inconvenience, but we’re currently experiencing some issues.  Contact our support team if you need assistance.</p>

                <br /><br />

                <PrimaryButton
                    buttonText={"Go Back Home"}
                    onClick={() => history.push('/')}
                />
            </div>

        </>

    );
};

export default Error500;
